<template>
  <ModalWindow
    :title="title"
    appearance="new"
    @close="$emit('close', $event)"
    class="promotion-modal__wrapper"
  >
    <div class="promotion-modal">
      <div
        class="promotion-modal__description"
        v-html="hrDayModalDescription"
      />
      <div class="promotion-modal__actions">
        <template v-if="promo.type === 'user' || promo.type === 'curator'">
          <BasicButton
            :href="promo.actionUrl"
            appearance="primary"
            size="l"
            rel="nofollow"
          >
            {{ actionButtonText }}
          </BasicButton>
          <BasicButton appearance="secondary" size="l" @click="$emit('close')"
            >Отменить
          </BasicButton>
        </template>
        <template v-else>
          <BasicButton href="/users/auth/tmid" appearance="primary" size="l">
            Войти
          </BasicButton>
          <BasicButton
            href="/users/auth/tmid/register"
            appearance="secondary"
            size="l"
          >
            Зарегистрироваться
          </BasicButton>
        </template>
      </div>
    </div>
  </ModalWindow>
</template>

<script>
import { month as MonthRef } from 'src/data/month.js';

import BasicButton from 'src/components/BasicButton/BasicButton.vue';
import ModalWindow from 'src/components/overlays/ModalWindow/ModalWindow.vue';

export default {
  name: 'PromotionModal',
  components: { BasicButton, ModalWindow },
  props: {
    title: {
      type: String,
      default: '',
    },
    promo: {
      type: Object,
      required: true,
    },
  },
  emits: ['close'],
  computed: {
    authRoute() {
      if (window.location.href.includes('career.habr.com')) {
        return 'https://career.habr.com';
      }

      return 'https://staging.career.habratest.net';
    },
    hrDayModalDescription() {
      switch (this.promo.type) {
        case 'user':
          return 'Создайте компанию, чтобы разместить вакансию бесплатно. Количество не ограничено, главное — успеть до 23:59.';
        case 'guest':
          return 'Зарегистрируйтесь или войдите как работодатель, чтобы разместить вакансию бесплатно. Количество не ограничено, главное — успеть до 23:59.';
        default:
          return 'Сегодня размещение всех вакансий бесплатно. Количество не ограничено, главное — успеть до 23:59.';
      }
    },
    modalDescription() {
      const endAtDate = new Date(this.promo.endAt);
      const endAtHumanized = [
        endAtDate.getDate(),
        MonthRef[endAtDate.getMonth()],
      ].join(' ');

      if (this.promo.type === 'user' || this.promo.type === 'curator') {
        return `Разместите первую вакансию компании со скидкой до ${endAtHumanized}.`;
      }
      return `Зарегистрируйтесь или войдите как работодатель и разместите первую вакансию компании со скидкой до ${endAtHumanized}.`;
    },
    actionButtonText() {
      return this.promo.type === 'curator' ? 'Разместить' : 'Создать';
    },
  },
};
</script>
